import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useContext,
  useImperativeHandle,
} from 'react';
import NoticeConfigurationStyled from './NoticeConfigurationStyled';
import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  useTheme,
} from '@material-ui/core';
import { useSelector } from 'dva';
import MessageML from '@/components/MessageML/index';
import { Context } from '../../AddMarketing';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'umi';

// eslint-disable-next-line no-unused-vars
export default forwardRef((props, fref) => {
  const {
    // control,
    noticeType,
    setNoticeType,
    noticePriority,
    setSelectedNoticeChannels,
    opt,
    onSubmit,
  } = props || {};
  const intl = useIntl();
  const { formatMessage } = intl;
  const [openSMS, setOpenSMS] = useState(false);
  const { ref } = useContext(Context);
  const submitRef = useRef();
  const clickInput = () => {
    submitRef.current.click();
  };
  useImperativeHandle(ref, () => ({
    clickInput: clickInput,
  }));

  const theme = useTheme();
  const { handleSubmit, control } = useForm();
  const [smsContent, setSmsContent] = useState();
  const [msgId, setMsgId] = useState();

  // 这里没有默认展示
  const [msgChecked, setMsgChecked] = useState(false);

  // 活动详情数据
  const sceneMarketingDetail = useSelector(
    (state) => state.sceneMarketing.sceneMarketingDetail,
  );

  //模板消息
  const [noticeChannels, setNoticeChannels] = useState([
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '1',
    },
  ]);
  //关于编辑或预览初始给模板消息赋值
  useEffect(() => {
    if (sceneMarketingDetail?.noticeChannels) {
      const receiveNoticeChannels = sceneMarketingDetail?.noticeChannels;
      const msgInfo = receiveNoticeChannels.filter((i) => i.type === '1')[0];
      const editNoticeChannels = receiveNoticeChannels.map((item) => {
        return { checked: true, ...item };
      });
      // let array = [];
      const newNoticeChannels = noticeChannels?.map((currentValue) => {
        let obj;
        let type = currentValue.type;
        const channel = editNoticeChannels.find((i) => i.type === type);
        if (channel) {
          obj = channel;
        } else {
          obj = currentValue;
        }
        return obj;
      });
      setNoticeChannels(newNoticeChannels);
      if (msgInfo) {
        setMsgChecked(true);
        setSmsContent(msgInfo?.msgContent);
        if (msgInfo.msgId) {
          setMsgId(Number(msgInfo?.msgId));
        }
      }
    }
  }, [sceneMarketingDetail]);
  let msgInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '1',
  );
  //拿到最新的值
  const handleSelectChange = (type, changes) => {
    let data = noticeChannels.concat();
    data.map((channel) => {
      if (channel.type === type.toString()) {
        channel.checked = changes.checked;
        channel.msgContent = changes.content;
        channel.msgId = changes.id;
      }
    });
    setSelectedNoticeChannels(data);
  };

  return (
    <NoticeConfigurationStyled theme={theme}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="basic-title">
          {formatMessage({ id: 'marketing.scene.holiday.n09.lbl01' })}
        </div>
        <div className="message-wrap">
          {/* 必须选中一项，两个可都选 */}
          <MessageML
            opt={opt}
            checked={msgChecked}
            setChecked={setMsgChecked}
            content={smsContent}
            setContent={setSmsContent}
            type={1}
            info={msgInfoItem}
            handleSelectChange={handleSelectChange}
            selectedId={msgId}
            setSelectedId={setMsgId}
            open={openSMS}
            setOpen={setOpenSMS}
          ></MessageML>
        </div>
        <FormLabel component="legend" className="notice-channel-title">
          <span className="label-require">*</span>
          {formatMessage({ id: 'marketing.scene.holiday.n10.lbl01' })}
          {/* 通知规则 */}
        </FormLabel>
        <Controller
          render={(rp) => (
            <RadioGroup
              aria-label="date"
              name="customized-radios"
              className="cycle-select-wrap"
              onChange={(e) => {
                setNoticeType(e.target.value);
                // setCouponUsingThresholdState(e.target.value);
                return rp.onChange(e.target.value);
              }}
              value={noticeType}
            >
              <FormControlLabel
                value="NOTICE_ONE"
                control={<Radio color="primary" disabled={opt === 'detail'} />}
                color="primary"
                label={formatMessage({
                  id: 'marketing.scene.holiday.n10.rdo02',
                })}
                className="all-level-select"
              />
              <div className="notice-channel-box">
                <div className="channel-box-title">
                  <span>
                    {formatMessage({ id: 'marketing.scene.holiday.c10.lbl01' })}
                  </span>
                  <span>
                    {formatMessage({ id: 'marketing.scene.holiday.c10.lbl02' })}
                  </span>
                </div>
                {noticePriority &&
                  noticePriority
                    .filter((item) => item.show)
                    .map((item, index) => {
                      return (
                        <div className="channel-box-content">
                          <span>{index + 1}</span>
                          <span>{item?.noticeChannelName}</span>
                        </div>
                      );
                    })}
              </div>
              <FormControlLabel
                value="NOTICE_ALL"
                control={<Radio color="primary" disabled={opt === 'detail'} />}
                color="primary"
                // label="所有渠道同步通知"
                label={formatMessage({
                  id: 'marketing.scene.holiday.n11.rdo01',
                })}
                className="all-level-select"
              />
              <div className="member-rules">
                {/* 同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用 */}
                {formatMessage({ id: 'marketing.scene.holiday.n11.txt02' })}
              </div>
            </RadioGroup>
          )}
          control={control}
          name="couponUsingThreshold"
          rules={{
            required: true,
          }}
        />
        <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
      </form>
    </NoticeConfigurationStyled>
  );
});
